import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';

//Service
import { BaseService } from '../../base/util/base.service';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';


@Injectable()
export class DropDownService extends BaseService{
    
    constructor(public http: HttpClient,public messageService: MessageService){
        super(http,messageService);        
    }
    
   //Recupera lista dos meses
   getMeses(){
    return this.http.get('./assets/json/meses.json');
   }

   getEstados(){
    return this.http.get('./assets/json/estados-br.json');
   }
  
} 


// WEBPACK FOOTER //
// ./src/app/components/base/util/dropdown.service.ts